import AdvancesearchRating from "../../components/AdvanceSearchRating";
import { order } from "../SmartSearchParammeter";

export default async function RatingSearchConfig(key) {
  return {
    description: "Rating",
    id: "rating",
    initial: undefined,
    type: order.fourth,
    handleValues: (searchObject) => {
      return;
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6  mt-5">
        <AdvancesearchRating
          searchObject={searchObject}
          setSearchObject={setSearchObject}
          t={t}
        />
      </div>
    ),
    operation: ["Between"],
    list: ["1", "2", "3", "4", "5"],
    examples: [
      `Natural Language: "I want a rating between 1 and 5\nStructured Query: "${key} Between 1, 5"`,
      `Natural Language: "I want a rating from 1\nStructured Query: "${key} Between 1, "`
    ],
    handler: function (searchObj, value) {
      searchObj["rating"] = value[0];
    }
  };
}
